import React from 'react';
import { Modal } from 'react-bootstrap';
import { IoStatsChartOutline, IoWalletOutline, IoCalendarOutline, IoLayersOutline, IoShieldCheckmarkOutline, IoTrendingUpOutline, IoCashOutline } from 'react-icons/io5';
import "./StakeDetailModal.css"
export default function StakeDetailModal({ stake, onClose }) {
  if (!stake) return null;

  const detailItem = (label, value, icon, color = "text-dark") => (
    <div className="bg-light p-2 px-3 rounded-2 border d-flex align-items-center justify-content-between h-100">
      <div className="text-muted fw-bold x-small d-flex align-items-center gap-2 text-uppercase">
        {icon} <span style={{ fontSize: '10px' }}>{label}</span>
      </div>
      <div className={`fw-bold small ${color}`} style={{ fontSize: '13px' }}>{value}</div>
    </div>
  );

  return (
    <>
      <style>
        {`
        .force-xl-modal {
          max-width: 1000px !important;
          width: 95% !important;
        }
        .compact-stake-card {
           border-radius: 12px !important;
           overflow: hidden;
        }
        @media (max-width: 1200px) {
          .force-xl-modal {
            max-width: 95% !important;
          }
        }
      `}
      </style>
      <Modal
        show={!!stake}
        onHide={onClose}
        centered
        dialogClassName="force-xl-modal"
        contentClassName="border-0 shadow-lg compact-stake-card"
      >
        <Modal.Header closeButton className="border-0 py-2" style={{ background: 'linear-gradient(90deg, #77a5ff 0%, #cfdfff 40.5%, #77a5ff 100%)' }}>
          <Modal.Title className="fs-6 fw-bold d-flex align-items-center gap-2 text-dark">
            <IoStatsChartOutline /> Stake Detail
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-white">
          <div className="row g-2">

            {/* Header Row */}
            <div className="col-12 mb-1">
              <div className="d-flex justify-content-between align-items-center p-2 px-3 bg-primary bg-opacity-10 rounded-2 border border-primary border-opacity-25">
                <div>
                  <small className="text-primary fw-bold d-block text-uppercase" style={{ fontSize: '10px' }}>Stake Type</small>
                  <span className="fw-bold text-primary" style={{ fontSize: '16px' }}>{stake.type || "Validator"}</span>
                </div>
                <div className="text-end">
                  <small className="text-muted fw-bold d-block text-uppercase" style={{ fontSize: '10px' }}>Status</small>
                  <span className={`badge ${stake.status === 'staked' ? 'bg-success' : 'bg-danger'} px-2 py-1 rounded-pill`} style={{ fontSize: '11px' }}>
                    {stake.status?.toUpperCase()}
                  </span>
                </div>
              </div>
            </div>

            {/* Grid Details */}
            {stake.type?.toLowerCase() !== 'delegator' && (
              <div className="col-12 col-md-4">
                {detailItem("Tier/Phase", stake.tierNumber || "N/A", <IoLayersOutline />)}
              </div>
            )}
            <div className={`col-12 ${stake.type?.toLowerCase() === 'delegator' ? 'col-md-12' : 'col-md-4'}`}>
              {detailItem("Base APR", `${stake.baseApr}%`, <IoTrendingUpOutline />, "text-primary")}
            </div>
            {stake.type?.toLowerCase() !== 'delegator' && (
              <div className="col-12 col-md-4">
                {detailItem("Voting Weight", stake.votingWeight || 0, <IoShieldCheckmarkOutline />)}
              </div>
            )}

            <div className="col-12 col-md-6">
              {detailItem("Investment (USDT)", `$${stake.priceInUsdt?.toFixed(2)}`, <IoCashOutline />, "text-primary")}
            </div>
            <div className="col-12 col-md-6">
              {detailItem("MForge Price at Stake", `$${stake.mforgePriceUSD?.toFixed(5)}`, <IoCashOutline />)}
            </div>

            <div className="col-12 col-md-6">
              {detailItem("Weekly Reward", `$${stake.projectedWeeklyReward?.toFixed(2)}`, <IoTrendingUpOutline />, "text-success")}
            </div>
            <div className="col-12 col-md-6">
              {detailItem("Annual Reward", `$${stake.projectedAnnualReward?.toFixed(2)}`, <IoTrendingUpOutline />, "text-success")}
            </div>

            <div className="col-12 col-md-6">
              {detailItem("Lock Period", stake.lockPeriod || "365 Days", <IoCalendarOutline />)}
            </div>
            <div className="col-12 col-md-6">
              {detailItem("Stake Fee", `${stake.networkStakeFee || 0}%`, <IoCashOutline />, "text-danger")}
            </div>

            <div className="col-12 col-md-12">
              {detailItem("Wallet Address", stake.walletAddress, <IoWalletOutline />, "x-small font-monospace")}
            </div>

            <div className="col-12 col-md-12">
              <div className="bg-light p-2 px-3 rounded-2 border d-flex align-items-center justify-content-between">
                <div className="text-muted fw-bold x-small d-flex align-items-center gap-2 text-uppercase">
                  <IoStatsChartOutline /> <span style={{ fontSize: '10px' }}>Transaction Hash</span>
                </div>
                <a
                  href={`${process.env.REACT_APP_EXPLORER_URL}/tx/${stake.transactionHash}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-primary text-decoration-none x-small font-monospace text-break text-end"
                  style={{ fontSize: '11px', maxWidth: '70%', wordBreak: 'break-all' }}
                >
                  {stake.transactionHash}
                </a>
              </div>
            </div>

            <div className="col-12 col-md-6">
              {detailItem("Payment Method", stake.paymentMethod, <IoCashOutline />)}
            </div>
            <div className="col-12 col-md-6">
              {detailItem("Stake Created", new Date(stake.createdAt).toLocaleString(), <IoCalendarOutline />)}
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
